import React from "react";
import cn from "classnames";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import "./ProgressionBar.scss";
import classNames from "classnames";
import { AlertType } from "../../../../../../interfaces/Dashboard";

interface Props {
    status: "none" | "inProgress" | "completed";
    alert?: AlertType;
    hover?: boolean;
    className?: string;
}

const ProgressionBar = ({
    status = "none",
    alert,
    hover = true,
    className,
}: Props) => {
    return (
        <div
            className={cn(
                "progression-bar",
                `--${status}`,
                {
                    "--hover": hover,
                },
                className
            )}
        >
            {alert && (
                <Icon
                    className={classNames(
                        "progression-bar__icon",
                        `--${alert}`
                    )}
                    path={`alert_${alert}`}
                    size="medium"
                    color={`alert-${alert}`}
                />
            )}
        </div>
    );
};

export default ProgressionBar;
